import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
} from "react-router-dom";
import {
  FiArrowUpRight,
  FiList,
  FiPlus,
  FiChevronUp,
  FiPlay,
} from "react-icons/fi";
import { history } from "./data/history";
import videos from "./data/videos.json";
import "./App.css";
import InteractiveOrb from "./components/InteractiveOrb";
import AmbientParticles from "./components/AmbientParticles";
const channel = "https://www.youtube.com/@marketingtalk";
const email = "miqueen71@naver.com";
const services = [
  [
    "01",
    "B2G",
    "정부사업 컨설팅",
    "정부사업 컨설팅",
    "정부 정책 분석, 사업 기획·운영 및 성과 평가를 지원합니다.",
    ["정부사업 기획 및 운영", "지역·전통시장 활성화", "성과 평가와 개선"],
  ],
  [
    "02",
    "B2B",
    "기업 컨설팅",
    "기업 컨설팅",
    "기업 현황 분석을 바탕으로 운영 전략, 임직원 교육, 마케팅·프로모션을 진행합니다.",
    ["비즈니스 운영 전략", "임직원 마케팅 교육", "브랜드·프로모션 기획"],
  ],
  [
    "03",
    "B2C",
    "소상공인 컨설팅",
    "소상공인 컨설팅",
    "음식점, 뷰티, 소매·유통, 서비스업 등 업종별 마케팅 전략과 실행을 지원합니다.",
    ["업종별 맞춤 전략", "온라인·SNS 마케팅", "실행 지원 및 성과 분석"],
  ],
];
function Label({ children }) {
  return (
    <p className="eyebrow">
      <span className="dot" />
      {children}
    </p>
  );
}
function ArrowLink({ to, children, external = false }) {
  return external ? (
    <a className="text-link" href={to} target="_blank" rel="noreferrer">
      {children}
      <FiArrowUpRight />
    </a>
  ) : (
    <Link className="text-link" to={to}>
      {children}
      <FiArrowUpRight />
    </Link>
  );
}
function FloatingNavigation() {
  const [open, setOpen] = useState(false);
  const dock = useRef(null);
  const toggle = useRef(null);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    const target = document.getElementById(location.hash.slice(1));
    if (target) target.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash, location.key]);
  useEffect(() => {
    const outside = (event) => {
      if (!dock.current?.contains(event.target)) setOpen(false);
    };
    const escape = (event) => {
      if (event.key === "Escape" && open) {
        setOpen(false);
        toggle.current?.focus();
      }
    };
    document.addEventListener("pointerdown", outside);
    document.addEventListener("keydown", escape);
    return () => {
      document.removeEventListener("pointerdown", outside);
      document.removeEventListener("keydown", escape);
    };
  }, [open]);
  return <div className="floating-nav" ref={dock} onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }}>
    {open && <nav className="contents-popover" id="page-contents" aria-label="페이지 목차">
      <p>페이지 목차</p>
      {[["top", "처음으로"], ["expertise", "사업 분야"], ["about", "대표 소개"], ["history", "연혁"], ["journal", "유튜브"], ["contact", "상담문의"]].map(([id, title]) =>
        <Link key={id} to={`/#${id}`} aria-current={location.hash === `#${id}` ? "location" : undefined} onClick={() => {
          setOpen(false);
          toggle.current?.focus();
        }}><span>{title}</span><FiArrowUpRight /></Link>
      )}
    </nav>}
    <Link to="/#contact" className="dock-contact">연락하기 <FiArrowUpRight /></Link>
    <button className="dock-contents" ref={toggle} aria-expanded={open} aria-controls="page-contents" onClick={() => setOpen(value => !value)} onKeyDown={event => {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
        setOpen(true);
        requestAnimationFrame(() => dock.current?.querySelector("nav a")?.focus());
      }
    }}><FiList />목차<FiChevronUp className={open ? "chevron expanded" : "chevron"} /></button>
  </div>;
}
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <span>상담문의</span>
        <a href={`mailto:${email}`}>
          {email}
          <FiArrowUpRight />
        </a>
      </div>
      <div className="footer-bottom">
        <Link to="/">
          iceo.co.kr <span>소장 : 최재봉</span>
        </Link>
        <span>© {new Date().getFullYear()} iCEO. All rights reserved.</span>
        <a href="#top" aria-label="맨 위로">
          맨 위로 ↑
        </a>
      </div>
    </footer>
  );
}
function Services() {
  return (
    <section className="section wrap expertise" id="expertise">
      <div className="section-heading">
        <Label>01 / 사업 분야</Label>
        <h2>컨설팅 · 교육</h2>
      </div>
      <div className="service-list">
        {services.map(([n, tag, title, , desc, items]) => (
          <article className="service" key={n}>
            <div className="service-top">
              <span className="service-no">{n}</span>
              <span className="service-tag">{tag}</span>
            </div>
            <h3>{title}</h3>
            <p>{desc}</p>
            <ul>
              {items.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
            <ArrowLink to={`/?service=${tag}#contact`}>상담 문의</ArrowLink>
          </article>
        ))}
      </div>
    </section>
  );
}
function Timeline() {
  return (
    <section className="history section wrap" id="history">
      <aside className="history-index">
        <Label>03 / 연혁</Label>
        <h2>2009—<br />2016</h2>
        <p className="small">연구소 소개 자료에 기록된 활동입니다.<br />연도를 선택하면 전체 이력을 볼 수 있습니다.</p>
      </aside>
      <div className="history-years">
        {history.map((y) => (
          <details className="year-entry" key={y.year} id={`year-${y.year}`}>
            <summary className="year-heading">
              <h3>{y.year}</h3>
              <span className="year-preview">{y.items[0].list[0]}</span>
              <FiPlus className="year-toggle" />
            </summary>
            <div className="history-content">
              {y.items.map((x) => (
                <section key={x.title}>
                  <h4>{x.title}</h4>
                  <ul>{x.list.map((line, j) => <li key={j}>{line}</li>)}</ul>
                </section>
              ))}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
function VideoSection() {
  return (
    <section className="journal" id="journal">
      <div className="wrap">
        <div className="journal-heading">
          <Label>04 / 유튜브</Label>
          <div className="journal-title">
            <h2>
              최재봉의
              <br />
              마케팅 톡톡
            </h2>
            <div>
              <ArrowLink to={channel} external>
                유튜브 채널 바로가기
              </ArrowLink>
            </div>
          </div>
          <div className="channel-stats">
            <div>
              <strong>
                7.49<span>만</span>
              </strong>
              <span>구독자</span>
            </div>
            <div>
              <strong>308</strong>
              <span>영상</span>
            </div>
            <p>
              YouTube 공개 수치 · 2026.09.11 확인
              <br />
              구독자·영상 수는 변동될 수 있습니다.
            </p>
          </div>
        </div>
        <div className="video-heading">
          <span>인기 영상</span>
        </div>
        <div className="video-grid">
          {videos.map((v, i) => (
            <a
              className="video"
              key={v.id}
              href={`https://www.youtube.com/watch?v=${v.id}`}
              target="_blank"
              rel="noreferrer"
            >
              <div className="video-image">
                <img
                  src={`/assets/youtube/${v.id}.jpg`}
                  alt=""
                  loading="lazy"
                />
                <span className="play">
                  <FiPlay />
                </span>
                <span className="duration">{v.duration}</span>
              </div>
              <div className="video-meta">
                <span>0{i + 1}</span>
                <span>{v.views}</span>
              </div>
              <h3>{v.title}</h3>
              <span className="watch-link">
                영상 보러가기 <FiArrowUpRight />
              </span>
            </a>
          ))}
        </div>
        <p className="source-note">
          YouTube 채널 인기순 · 2026.09.11 확인 · 게시 당시의 내용을 담은
          영상입니다.
        </p>
      </div>
    </section>
  );
}
function Home() {
  return (
    <>
      <section className="hero wrap">
        <div className="hero-title">
          <Label>실전마케팅연구소</Label>
          <h1>
            ICEO<span className="hero-period">.</span>
          </h1>
          <p className="hero-description">마케팅 컨설팅 · 기업 교육 · 강연</p>
        </div>
        <div className="hero-visual">
          <InteractiveOrb />
          <p className="orb-caption">정부사업, 대기업, 소상공인 모두<br /><strong>각자에 맞는 전략으로.</strong></p>
        </div>
        <a className="hero-scroll" href="#expertise">사업 분야 살펴보기 <span>↓</span></a>
      </section>
      <Services />
      <About />
      <Timeline />
      <VideoSection />
      <Contact />
    </>
  );
}
function About() {
  return (
    <>
      <section className="about-hero wrap section" id="about">
        <Label>02 / 대표 소개</Label>
        <div className="about-grid">
          <figure>
            <img src="/assets/profile_ceo.jpeg" alt="ICEO 대표 최재봉" loading="lazy" />
            <figcaption>ICEO 대표 최재봉</figcaption>
          </figure>
          <div>
            <span className="founder-role">현재 · 족장에프앤비 대표 · ICEO실전마케팅연구소 대표</span><h2 className="founder-name">최재봉</h2>
            <p>
              관공서, 대기업, 중소기업, 소상공인을 대상으로 마케팅 컨설팅과
              교육을 진행합니다.
            </p>
            <p>
              주요 분야는 정부사업 기획·운영, 기업 마케팅·프로모션, 임직원 교육,
              온라인·SNS 마케팅입니다.
            </p>
          </div>
        </div>
      </section>
      <section className="profile wrap section">
        <Label>대표 최재봉</Label>
        <div>
          <h2>경력 · 수상 · 저서</h2>
          <p className="small">네이버 인물정보와 기존 연구소 소개 자료를 기준으로 정리했습니다.</p>
          <ul className="profile-list">
            {[
              ["현재", "족장에프앤비 대표"],
              ["현재", "iCEO실전마케팅연구소 대표"],
              ["현재", "iCEO 평생교육원 원장"],
              ["현재", "(주)비즈인포그룹 대표이사"],
              ["2015.08.", "고려대학교 온라인마케팅 최고경영자과정 외래교수"],
              ["2014.11.", "서울특별시 소셜특별시 자문위원회 자문위원"],
              ["2013.10.–12.", "네이버비즈니스플랫폼 파트너스퀘어 초빙강사"],
              ["수상 · 2013", "서울지방중소기업청장 표창"],
              ["수상 · 2013", "한국신지식인협회 대한민국 신지식인"],
            ].map(([period, title]) => (
              <li key={`${period}-${title}`}>
                <span className="dot" />
                <span className="career-period">{period}</span>
                <span>{title}</span>
              </li>
            ))}
          </ul>
          <div className="books">
            <h3>도서</h3>
            <ul>
              {[
                ["2016.05.10.", "성공하는 구이전문점 창업하기"],
                ["2015.11.01.", "모바일 마케팅 상위 노출 비법"],
                ["2015.02.25.", "페이스북&카카오스토리 마케팅 비법"],
                ["2013.09.05.", "인터넷 쇼핑몰 실전 마케팅 무작정따라하기 (최신 개정판)"],
                ["2012.10.01.", "인터넷 쇼핑몰 마케팅 비법"],
                ["2009.02.28.", "인터넷 쇼핑몰 실전 마케팅 무작정 따라하기"],
              ].map(([date, title]) => <li key={title}><time>{date}</time><span>{title}</span></li>)}
            </ul>
          </div>
        </div>
      </section>

    </>
  );
}
function Contact() {
  const [status, setStatus] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const service =
    new URLSearchParams(useLocation().search).get("service") || "";
  const [mailReady, setMailReady] = useState(false);
  useEffect(() => {
    fetch("/api/health").then(r => r.ok ? r.json() : null)
      .then(data => setMailReady(data?.mailConfigured === true)).catch(() => {});
  }, []);
  useEffect(() => {
    const select = document.querySelector('select[name="service"]');
    if (select) select.value = service;
  }, [service]);
  async function submit(e) {
    e.preventDefault();
    if (sending) return;
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form));
    if (!mailReady) {
      const body = `성함: ${data.name}\n회사 / 브랜드: ${data.company}\n이메일: ${data.email}\n연락처: ${data.phone}\n문의 분야: ${data.service}\n\n${data.message}`;
      window.location.href = `mailto:${email}?subject=${encodeURIComponent("ICEO 상담문의")}&body=${encodeURIComponent(body)}`;
      setStatus("메일 앱에서 내용을 확인한 뒤 전송해 주세요. 이 화면에서는 메일이 발송되지 않습니다.");
      return;
    }
    setSending(true);
    setSent(false);
    setStatus("문의 내용을 보내고 있습니다.");
    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      if (!response.ok)
        throw new Error(
          result.message || "발송하지 못했습니다. 잠시 후 다시 시도해 주세요.",
        );
      setSent(true);
      setStatus(
        "문의 메일이 발송되었습니다. 남겨주신 이메일로 답변드리겠습니다.",
      );
      form.reset();
    } catch (err) {
      setStatus(
        err.message === "Failed to fetch"
          ? "연결을 확인한 후 다시 시도해 주세요."
          : err.message,
      );
    } finally {
      setSending(false);
    }
  }
  return (
    <section className="contact wrap section" id="contact">
      <Label>05 / 함께 시작하기</Label>
      <h2>상담문의</h2>
      <div className="contact-grid">
        <div className="contact-intro">
          <a className="contact-email" href={`mailto:${email}`}>
            {email}
            <FiArrowUpRight />
          </a>
          <dl>
            <dt>전화</dt>
            <dd>
              <a href="tel:0234743055">02-3474-3055</a>
            </dd>
            <dt>주소</dt>
            <dd>서울특별시 서초구 서운로 13, 502호</dd>
          </dl>
          <p className="small">
            (주)아이씨이오실전마케팅연구소
            <br />
            사업자등록번호 220-88-52833 · 대표 최재봉
          </p>
        </div>
        <form onSubmit={submit}>
          <div className="form-row">
            <label>
              성함 <span>*</span>
              <input
                name="name"
                autoComplete="name"
                required
                maxLength={80}
                placeholder="성함"
              />
            </label>
            <label>
              회사 / 브랜드
              <input
                name="company"
                autoComplete="organization"
                maxLength={100}
                placeholder="회사 또는 브랜드명"
              />
            </label>
          </div>
          <div className="form-row">
            <label>
              이메일 <span>*</span>
              <input
                name="email"
                type="email"
                autoComplete="email"
                required
                maxLength={254}
                placeholder="답변받으실 이메일"
              />
            </label>
            <label>
              연락처
              <input
                name="phone"
                type="tel"
                autoComplete="tel"
                maxLength={40}
                placeholder="연락 가능한 번호"
              />
            </label>
          </div>
          <label>
            문의 분야
            <select name="service" defaultValue={service}>
              <option value="">문의 분야 선택</option>
              <option value="B2G">정부사업 컨설팅</option>
              <option value="B2B">기업 컨설팅</option>
              <option value="B2C">소상공인 컨설팅</option>
              <option value="LECTURE">교육 · 강연</option>
              <option value="OTHER">기타 · 협업 제안</option>
            </select>
          </label>
          <label>
            문의 내용 <span>*</span>
            <textarea
              name="message"
              required
              minLength={10}
              maxLength={5000}
              rows={5}
              placeholder="문의 내용을 입력해 주세요. (10자 이상)"
            />
          </label>
          <div className="honey" aria-hidden="true">
            <label>
              웹사이트
              <input name="website" tabIndex={-1} autoComplete="off" />
            </label>
          </div>
          <details className="privacy">
            <summary>개인정보 수집·이용 안내</summary>
            <p>
              수집 항목: 성함, 이메일, 회사·브랜드 및 연락처(선택), 문의 내용.
              이용 목적: 상담 문의 확인 및 답변. 문의 내용은 연구소 이메일로
              전달되며 상담 완료 후 90일 이내 삭제합니다. 동의를 거부할 수
              있으나 상담 접수는 제한됩니다.
            </p>
          </details>
          <label className="consent">
            <input type="checkbox" name="consent" value="yes" required />
            상담을 위한 개인정보 수집·이용에 동의합니다. (필수)
          </label>
          <button className="submit" disabled={sending}>
            {sending ? "보내는 중…" : mailReady ? "상담 문의 보내기" : "메일 앱에서 문의 작성하기"}
            <FiArrowUpRight />
          </button>
          <p className="form-hint">
            {!mailReady && "작성한 내용을 메일 앱으로 옮깁니다. 메일 앱에서 직접 전송해 주세요. "}문의는 {email}으로 전달됩니다.</p>
          {status && (
            <p role={sent ? "status" : "alert"} className="form-status">
              {status}
              {!sent && !sending && (
                <>
                  {" "}
                  <a href={`mailto:${email}`}>이메일로 직접 문의하기 ↗</a>
                </>
              )}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
function LegacyContact() {
  const { search } = useLocation();
  return <Navigate to={`/${search}#contact`} replace />;
}
export default function App() {
  return (
    <BrowserRouter>
      <a className="skip" href="#main">
        본문으로 건너뛰기
      </a>
      <AmbientParticles />
      <div id="top" />
      <FloatingNavigation />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Navigate to="/#about" replace />} />
          <Route path="/contact" element={<LegacyContact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
